"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const AuthFormReducer_1 = require("../../authForm/reducers/AuthFormReducer");
const AuthFormSaga_1 = tslib_1.__importDefault(require("../../authForm/sagas/AuthFormSaga"));
const loadAuthenticationFormModule = () => ({
    id: 'AuthenticationForm',
    reducerMap: {
        authForm: AuthFormReducer_1.authFormReducer,
    },
    sagas: [AuthFormSaga_1.default],
});
exports.default = loadAuthenticationFormModule;
